import { FC } from 'react';

export const Fields: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2 7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V8C22 9.65685 20.6569 11 19 11H5C3.34315 11 2 9.65685 2 8V7ZM5 6C4.44772 6 4 6.44772 4 7V8C4 8.55228 4.44772 9 5 9H19C19.5523 9 20 8.55228 20 8V7C20 6.44772 19.5523 6 19 6H5ZM2 16C2 14.3431 3.34315 13 5 13H10C11.6569 13 13 14.3431 13 16V17C13 18.6569 11.6569 20 10 20H5C3.34315 20 2 18.6569 2 17V16ZM5 15C4.44772 15 4 15.4477 4 16V17C4 17.5523 4.44772 18 5 18H10C10.5523 18 11 17.5523 11 17V16C11 15.4477 10.5523 15 10 15H5ZM18.5 13C19.0523 13 19.5 13.4477 19.5 14V15.5H21C21.5523 15.5 22 15.9477 22 16.5C22 17.0523 21.5523 17.5 21 17.5H19.5V19C19.5 19.5523 19.0523 20 18.5 20C17.9477 20 17.5 19.5523 17.5 19V17.5H16C15.4477 17.5 15 17.0523 15 16.5C15 15.9477 15.4477 15.5 16 15.5H17.5V14C17.5 13.4477 17.9477 13 18.5 13Z"
			fill="currentColor"
		/>
	</svg>
);
